export default __webpack_public_path__ + "static/media/epic.3550ed5e.svg";